import { Typography } from "@mui/material";
import { styled as muiStyled } from "@mui/system";
import styled from "styled-components";

// const COLORS = {
//     cardBg: "#0A1A3C",
//     cardHover: "#122855",
//     arrowBg: "#DDDDDD",
//     arrowHover: "#EEE",
//     arrowColor: "#9F9999",
// };

export const ContainerCoupons = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid darkgray;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
    

    @media (max-width: 768px) {
        align-items: normal;
        justify-content: start;
        gap: 0px;
    }
`;

export const CouponBox = styled.div`
    display: flex;
    align-items: center;
    padding: 15px 10px;

    gap: 10px;
    border-top: 1px solid darkgray;
`;

export const StoreImage = styled.img`
    width: 80px;
    border-radius: 5px;
    border: 1px solid darkgray;
`;

export const StoreName = styled.div`
    font-size: 10px;
    font-weight: 900;
    color: #0095FE;
`;

export const Description = styled.div`
    font-size: 10px;
    font-weight: 600;
    color: #363636;
`;

export const DescriptionBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: left;
    gap: 5px;
`;

export const ButtonWrapper = styled.div`
  position: relative;
  display: inline-block;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border: 2px dashed #0095FE;
    border-radius: 16px;

    opacity: 0.4;
    z-index: 0;
  }
`;

export const CouponButton = styled.div`
  align-items: center;
  justify-content: center;
  display: flex ;
  z-index: 1;
  width: 128px;
  height: 45px;
  gap: 5px;
  padding: 0px 5px ;

  background-color: #0095FE;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 12px;

  font-weight: 600;
  border-radius: 16px;

  clip-path: polygon(
    0 0,
    calc(100% - 22px) 0,
    100% 22px,
    100% 100%,
    0 100%
  );

    @media(max-width: 768px){
        padding: 8px;
        font-size: 12px;
        width: auto;
        height: auto;
    }
`;

export const LockBadge = styled.div`
    cursor: pointer;
    width: 34px;
    height: 34px;
    border: 2px dashed white;
    border-radius: 50%;
    background-color: #0095FE;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
    z-index: 10;

    @media(max-width: 768px){
        left: ${({ isCouponButton }) => (isCouponButton ? '60%' : '50%')};
        width: 25px;
        height: 25px;
    }
`;





// export const ArrowButtonLeft = styled(ArrowButton)`
//     left: 0;
// `;